module.exports = __webpack_public_path__ + "img/5.e2c1cb72.jpg";